export default __webpack_public_path__ + "static/logos-cd3445699b6349b1ded43b6ee67933f6.jpg";